import { Badge, Tab, Tabs } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { useEffect, useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { matchPath, useLocation } from 'react-router'
import { NavigationItem } from '../../../containers/Navigation/types'
import { isNumStep } from '../../../utils/apartments'

interface MenuItemsProps extends WithTranslation {
  navigate: (arg: any) => void
  openDialog: (arg: any) => void
  navItems: NavigationItem[]
  currentPath: string
  classes: any
  unreadMessages: number
}

const tabStyles = (theme: any) => ({
  root: {
    backgroundColor: 'inherit',
    height: '69px'
  },
  wrapper: {
    padding: '0 34px',
    borderRight: '1px solid #65AB5B',
    borderLeft: '1px solid #65AB5B',
    '&:last-child': {
      borderRight: 'none'
    }
  }
})

const getContextHighlightedIndex = {
  '/overview': 0,
  '/applications': 1,
  '/messages': 2,
  '/showings/overview': 3,
  '/apartments': 4,
  '/profile': 5
}
const getHighlightedIndex = {
  '/apartments': 1,
  '/messages': 0,
  '/profile': 2
}
const StyledTab = withStyles({
  selected: {
    background: '#3f7c36',
    padding: '0 35px !important',
    borderRight: 'none !important',
    borderLeft: 'none !important'
  }
})((props: any) => <Tab variant='fullWidth' {...props} />)

const NavTabs = ({
  navigate,
  navItems,
  currentPath,
  classes,
  unreadMessages,
  t
}: MenuItemsProps) => {
  const mathcedUrl: any = matchPath(window.location.pathname, {
    path: '/users/:userId/apartments/:apartmentId'
  })
  const [currentKey, setCurrentKey] = useState('')
  const location = useLocation()

  useEffect(() => {
    const navIds = navItems.map(({ id }) => id)
    if (navIds.includes(currentPath)) setCurrentKey(currentPath)
  }, [currentPath, location])

  const BadgeIcon = ({ children, rootId }: any) => {
    return (
      <>
        {rootId === '/messages' ? (
          <Badge badgeContent={unreadMessages} color='secondary'>
            {children}
          </Badge>
        ) : (
          <>{children}</>
        )}
      </>
    )
  }

  const isClientStage = isNumStep(location.pathname, '12')
  return (
    <Tabs
      value={
        mathcedUrl?.params?.apartmentId && mathcedUrl?.params?.userId
          ? getContextHighlightedIndex[currentKey] !== undefined
            ? getContextHighlightedIndex[currentKey]
            : 0
          : getHighlightedIndex[currentKey] !== undefined
          ? getHighlightedIndex[currentKey]
          : 0
      }
      className={classes.root}
    >
      {navItems.map(({ id, label, icon: Icon }) => {
        if (
          mathcedUrl?.params?.apartmentId &&
          mathcedUrl?.params?.userId &&
          (id === '/applications' ||
            id === '/showings/overview' ||
            id === '/messages' ||
            id === '/overview') &&
          !location.pathname.includes('steps')
        ) {
          return (
            <StyledTab
              icon={
                <BadgeIcon rootId={id}>
                  <Icon />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                setCurrentKey(id)
                navigate(mathcedUrl.url + id)
              }}
            />
          )
        } else if (
          ((!(mathcedUrl?.params?.apartmentId && mathcedUrl?.params?.userId) ||
            location.pathname.includes('steps')) &&
            (id === '/profile' || id === '/messages')) ||
          id.toLowerCase().includes('apartments')
        ) {
          return (
            <StyledTab
              icon={
                <BadgeIcon rootId={id}>
                  <Icon
                    style={
                      id.toLowerCase().includes('apartments')
                        ? {
                            marginBottom: '10px',
                            marginTop: '5px'
                          }
                        : {}
                    }
                  />
                </BadgeIcon>
              }
              label={t(label)}
              key={id}
              disabled={isClientStage}
              className={classes.wrapper}
              onClick={() => {
                setCurrentKey(id)
                navigate(id)
              }}
            />
          )
        }
        return null
      })}
    </Tabs>
  )
}
export default withTranslation()(
  withStyles(tabStyles, { withTheme: true })(NavTabs) as any
) as any
